module.exports = __webpack_public_path__ + "img/silica_icon.9535975c.svg";